export default async function api(
  path: string,
  data: string | object,
  config?: { method: string; rootUrl: string }
) {
  let { method, rootUrl } = config || {}
  if (!rootUrl) rootUrl = getRootUrl()

  if (rootUrl && rootUrl.endsWith('/')) rootUrl = rootUrl.slice(0, -1)
  const fullPath = `${rootUrl || ''}/api${path}` //getPath(path)

  const result = await fetch(fullPath, {
    method: method || 'POST',
    body: JSON.stringify({ data }),
    headers: { 'Content-Type': 'application/json' },
  })
  const dataObj = await result.json()
  return { data: dataObj }
}

function getRootUrl() {
  // const hostIsLocal =
  //   window.location.host.startsWith('localhost') && !localStorage.SavvyDebugUseFlowsEndpoint
  // const hostIsDeployedWebApp =
  //   window.location.host === 'staging.trysavvy.com' || window.location.host === 'app.trysavvy.com'
  // const isReviewApp = process.env.VUE_APP_IS_REVIEW_APP
  // return hostIsLocal || hostIsDeployedWebApp || `https://flows.trysavvy.com`

  return `https://flows.trysavvy.com`
}
